import makeStyles from '@material-ui/core/styles/makeStyles';
import { darken } from "@material-ui/core/styles";

const TAB_HEADER_HEIGHT = 48;
const TAB_FOOTER_HEIGHT = 60;

const makeButtonStyles = ({ color, backgroundColor, hoverColor }) => ({
    borderRadius: 6,
    backgroundColor: backgroundColor,
    color: color,
    '&:focus': {
      backgroundColor: backgroundColor,
    },
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: hoverColor,
        color: color,
      },
    },
    '@media (hover: none)': {
      '&:hover': {
        backgroundColor: backgroundColor,
        color: color,
      },
    },
});

const useStyles = makeStyles((theme) => ({
  paper: {
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      height: '80%',
    },
  },
  tabIndicator: {
    backgroundColor: theme.palette.colors.readerPrimaryColor,
  },
  container: {
    width: '100%',
    height: '100vh',
    minWidth: '300px',
    maxWidth: '450px',
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.barColor,
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      height: '100%',
    },
  },
  tabHeader: {
    borderBottom: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  tabs: {
    height: TAB_HEADER_HEIGHT,
  },
  tabPanel: {
    width: '100%',
    overflowY: 'auto',
    position: 'relative',
    maxHeight: `calc(100% - ${TAB_HEADER_HEIGHT}px)`,
  },
  navItem: {
    flexDirection: 'column',
    alignItems: 'start',
    borderBottom: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
    padding: 10,
  },
  itemColor: {
    width: 18,
    height: 18,
    borderRadius: 4,
    marginRight: 6,
    display: 'inline-block',
    boxShadow: 'inset 0 0 0 1px rgb(0 0 0 / 4%)',
  },
  navItemTitle: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  navItemMetadata: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  navItemSubTitle: {
    fontSize: 14,
    whiteSpace: 'normal',
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  emptyMessageTitle: {
    fontSize: 16,
    marginTop: 50,
    marginBottom: 4,
    textAlign: 'center',
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  emptyMessageSubtitle: {
    fontSize: 14,
    textAlign: 'center',
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  exportBookmarks: {
    ...makeButtonStyles({
      color: theme.palette.colors.readerPrimaryColor,
      backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.barColor,
      hoverColor: ({ activeTheme }) => darken(theme.reader.colors[activeTheme]?.barColor, 0.1),
    }),
    borderColor: theme.palette.colors.readerPrimaryColor,
    marginRight: 10,
  },
  listContainer: {
    height: '100%',
    overflow: 'scroll',
  },
  bookmarkTabPanel: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'unset',
    '& > :first-child': {
      height: `calc(100vh - ${TAB_HEADER_HEIGHT}px - ${TAB_FOOTER_HEIGHT}px)`,
      padding: '0 24px',
    },
    '& $emptyMessageTitle': {
        marginTop: 50 + 24,
    }
  },
  bookmarkPanelBottom: {
    height: TAB_FOOTER_HEIGHT,
    width: 'calc(100% + 48px)',
    marginLeft: '-24px',
    alignSelf: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    borderTop: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
  },
  optionsButton: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...makeButtonStyles({
      color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
      backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
      hoverColor: ({ activeTheme }) => darken(theme.reader.colors[activeTheme]?.backdropColor, 0.1),
    }),
  },
  optionsIcon: {
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
    '@media (hover: hover)': {
      '&:hover': {
        color: theme.palette.colors.readerPrimaryColor,
      },
    },
  },
  popper: {
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
  },
  dropdownItem: {
    justifyContent: "left",
    padding: '24px 12px',
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropColor,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  dropdownIcon: {
    width: 16,
    height: 16,
    marginRight: 5,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  dropdownLabel: {
    marginLeft: 5,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropOnColor,
  },
  deleteDropdownItem: {
    color: theme.palette.colors.errorColor,
    '& $dropdownLabel': {
      color: theme.palette.colors.errorColor,
    },
    '& $dropdownIcon': {
      color: theme.palette.colors.errorColor,
    }
  },
}));

export default useStyles;
